export const WORKSPACE_PATH = {
  DEFAULT: '/workspaces/{id}',
}

export const MANAGE_PATH = {
  DEFAULT: 'manage-assignments?tab=assign-logic',
  ROLE: 'manage-assignments?tab=role-settings',
}

export const QACHAT_PATH = {
  DEFAULT: '/qa-chat',
  RECENT_CONVERSATION_DETAILS: '/qa-chat/recent-conversation-details?conversation_id={id}',
}

export const DATA_CENTER_PATH = {
  DEFAULT: '/data-center',
}

export const MEMBERS_PATH = {
  DEFAULT: '/members',
}

export const SETTINGS_PATH = {
  DEFAULT: '/settings',
  DYNAMIC_TAB: '/settings?tab={tab}',
}

export const PROFILE_PATH = {
  DEFAULT: '/profile?tab=information',
  SETTINGS: '/profile?tab=settings',
  DYNAMIC_TAB: '/profile?tab={tab}',
}

export const AUTH_PATH = {
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  TENANT_SELECTION: '/tenant-selection',
  SELECT_WORKSPACE: '/select-workspace',
}

export const ERRORS_PATH = {
  NO_ACCESS: '/no-access',
  NOT_FOUND: '/404', // Changed from /not-found to match existing route
}
